import type { Components } from '@mildang/mui';

// TODO: use // import isChromatic from 'chromatic/isChromatic';
// @ts-ignore
function isChromatic(windowArg) {
  const windowToCheck = windowArg || (typeof window !== 'undefined' && window);
  return !!(
    windowToCheck &&
    (windowToCheck.navigator.userAgent.match(/Chromatic/) ||
      windowToCheck.location.href.match(/chromatic=true/))
  );
}

const createProgress = (): Components => ({
  MuiCircularProgress: {
    // https://www.chromatic.com/docs/animations#javascript-animations
    // @ts-ignore
    defaultProps: isChromatic()
      ? {
          variant: 'determinate',
          value: 45,
        }
      : {},
  },
});

export default createProgress;
